export const EMPTY_SLOT_HEIGHT = 12;
export const SKELETON_HOURLY_SLOT_HEIGHT = 45;
export const SKELETON_FULL_HOURLY_SLOT_HEIGHT = 90;
export const DAILY_SKELETON_ELEMENTS_COUNT = 24;

export const DRAGGABLE_ID_SEPARATOR = '_';
export const getDraggableId = (slotId: number, resourceId?: string) =>
	resourceId ? `${slotId}${DRAGGABLE_ID_SEPARATOR}${resourceId}` : slotId;

export const getCompoundDraggableId = (slotId: number, resourceId?: string, date?: string) => {
	// Use underscore consistently for compound IDs to match droppable pattern
	const baseId = resourceId ? `${slotId}${DRAGGABLE_ID_SEPARATOR}${resourceId}` : `${slotId}`;

	if (date) {
		return `${baseId}_${date}`;
	}

	return baseId;
};
